import { buildUrl, deleteRequest, get, post, put } from "../utils/axios-requests";
import {
  DEFAULT_HTTP_TIMEOUT,
  MASBRAN_API_CHECK,
  MASBRAN_API_DELETE_SESSION,
  MASBRAN_API_DELETE_USER,
  MASBRAN_API_GET_ACTIVE_SESSIONS,
  MASBRAN_API_GET_ACTIVE_SESSIONS_BY_USER,
  MASBRAN_API_GET_DEVICES,
  MASBRAN_API_GET_USER,
  MASBRAN_API_GET_USERS,
  MASBRAN_API_GET_USERS_CRM,
  MASBRAN_API_LOGIN,
  MASBRAN_API_LOGIN_PERMISSIONS,
  MASBRAN_API_LOGOUT,
  MASBRAN_API_POST_BLOCK_USER,
  MASBRAN_API_POST_DOUBLE_FACTOR_UPDATE,
  MASBRAN_API_POST_REGISTER_DEVICE,
  MASBRAN_API_POST_UPDATE_CREDENTIAL,
  MASBRAN_API_POST_UPDATE_LOGIN,
  MASBRAN_API_POST_USER_DATA,
  MASBRAN_API_POST_VALIDATE_LANDING_CREDENTIALS,
  MASBRAN_API_POST_VALIDATE_LOGIN_CREDENTIALS,
  MASBRAN_API_POST_VALIDATE_SECURITY_CREDENTIALS,
  ROUTES_LOGIN,
  SEARCH_TAB_ID_CRM,
  SEARCH_TAB_LOGIN,
  SESSION_SECURITY_ROLE_KEY,
  SESSION_TOKEN_STORAGE_KEY,
  SESSION_USER_ID_KEY,
  SESSION_USER_TENANTS_KEY,
} from "../utils/constants";
import { clearSession, clearStorage } from "../utils/utils";

export const loginService = (data, thenCallback, catchCallback) => {
  post(MASBRAN_API_LOGIN, data, {}, false, thenCallback, catchCallback, {}, undefined, true, false);
};

export const getSecurityContextService = () => {
  const callback = (response) => {
    sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, response.sessionToken);
    sessionStorage.setItem(SESSION_USER_TENANTS_KEY, JSON.stringify(response.tenants));
    sessionStorage.setItem(SESSION_USER_ID_KEY, response.userId);
    sessionStorage.setItem(SESSION_SECURITY_ROLE_KEY, response.securityRole);
  };

  get(MASBRAN_API_LOGIN_PERMISSIONS, {}, false, callback);
};

export const checkSessionService = () => {
  const errorCallback = () => {
    clearSession();
  };

  get(MASBRAN_API_CHECK, {}, false, null, errorCallback);
};

const logoutCallback = () => {
  window.location.pathname = ROUTES_LOGIN;
  clearStorage();
};

export const logoutService = () => {
  get(MASBRAN_API_LOGOUT, {}, false, logoutCallback);
};

export const getActiveSessions = (idCrm, callback) => {
  const url = buildUrl(MASBRAN_API_GET_ACTIVE_SESSIONS, { idCrm });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getUserActiveSessions = (idCrm, idUser, callback) => {
  const url = buildUrl(MASBRAN_API_GET_ACTIVE_SESSIONS_BY_USER, { idCrm, idUser });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const deleteSession = (idCrm, idSession, callback) => {
  const url = buildUrl(MASBRAN_API_DELETE_SESSION, { idCrm, idSession });
  deleteRequest(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getUsers = (tab, dni, idLogin, idCrm, callback) => {
  let url;
  let variables = {};

  if (tab === SEARCH_TAB_ID_CRM) {
    url = MASBRAN_API_GET_USERS_CRM;
    variables.idCrm = idCrm;
  } else if (tab === SEARCH_TAB_LOGIN) {
    url = MASBRAN_API_GET_USERS + "loginId=:loginId";
    variables.loginId = idLogin;
  } else {
    url = MASBRAN_API_GET_USERS + "nifCif=:nifCif";
    variables.nifCif = dni;
  }

  get(buildUrl(url, variables), { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getUser = (idCrm, idUser, callback) => {
  const url = buildUrl(MASBRAN_API_GET_USER, { idCrm, idUser });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const putUserData = (idCrm, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_USER_DATA, { idCrm });
  put(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, undefined, {}, message);
};

export const putValidateSecurityCredentials = (idCrm, idUser, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_VALIDATE_SECURITY_CREDENTIALS, { idCrm, idUser });
  put(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const postValidateLandingCredentials = (idCrm, idUser, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_VALIDATE_LANDING_CREDENTIALS, { idCrm, idUsuario: idUser });
  post(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const postValidateLoginCredentials = (idLogin, callback, message) => {
  post(
    `${MASBRAN_API_POST_VALIDATE_LOGIN_CREDENTIALS}?${idLogin}`,
    {},
    { timeout: DEFAULT_HTTP_TIMEOUT },
    true,
    callback,
    null,
    {},
    message,
  );
};

export const putLoginUpdate = (idCrm, idUser, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_UPDATE_LOGIN, { idCrm, idUser });
  put(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const putCredentialUpdate = (idCrm, idUser, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_UPDATE_CREDENTIAL, { idCrm, idUser });
  put(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const putDoubleFactorUpdate = (idCrm, idUser, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_DOUBLE_FACTOR_UPDATE, { idCrm, idUser });
  put(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const postBlockUser = (idCrm, body, callback, message) => {
  const url = buildUrl(MASBRAN_API_POST_BLOCK_USER, { idCrm });
  post(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};

export const getUserDevices = (idCrm, idUser, callback) => {
  const url = buildUrl(MASBRAN_API_GET_DEVICES, { idCrm, idUser });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const postRegisterDevice = (idCrm, idUser, body, callback) => {
  const url = buildUrl(MASBRAN_API_POST_REGISTER_DEVICE, { idCrm, idUser });
  post(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const deleteUserAccountService = (idCrm, idUser, callback, message) => {
  const url = buildUrl(MASBRAN_API_DELETE_USER, { idCrm, idUser });
  deleteRequest(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, null, {}, message);
};
